import styled from "styled-components";

interface IScreen {
  size?: string
}

export const GreenText = styled.span`
  color: #01C716;
`

export const Screen = styled.div<IScreen>`
  padding: ${({ size }) => size === 'large' ? '140px 25px 80px' : '40px 25px'};
  position: relative;

  @media (min-width: 980px) {
    padding: ${({ size }) => size === 'large' ? '140px 40px 80px' : '80px 40px'};
  }
`

export const TitleH1 = styled.h1`
  font-size: 24px;
  line-height: 140%;
  text-align: center;
  font-weight: 700;
  
  @media (min-width: 980px) {
    font-weight: 600;
    font-size: 56px;
  }
`

export const TitleH2 = styled.h2`
  font-size: 24px;
  line-height: 140%;
  text-align: center;
  font-weight: 700;

  @media (min-width: 980px) {
    font-weight: 600;
    font-size: 36px;
  }
`

export const SubTitle = styled.div`
  font-size: 28px;
  line-height: 140%;
  color: #2A2637;
  text-align: center;
  font-weight: 600;
  margin-top: 25px;
  display: none;
  
  @media (min-width: 980px) {
    display: block;
  }
`

export const BottomLine = styled.div`
  position: absolute;
  bottom: 0;
  left: 20px;
  right: 20px;
  height: 1px;
  background: #E0DDEC;

  @media (min-width: 980px) {
    left: 92px;
    right: 92px;
  }
`